import mainCaller from "./mainCaller";
import QueryString from 'qs';

export const getAllTransferPasses = async (query, token) => {
  // const queryString = QueryString.stringify(query)
  return await mainCaller(`admin/api/v1/transfer/passes?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export const getAllTransferTickets = async (query, token) => {
  // const queryString = QueryString.stringify(query)
  return await mainCaller(`admin/api/v1/transfer/tickets?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 같은 이름·전화번호 회원이 여러 명일 수 있어 receiverMemberId 로 대상을 지정한다.
// 후보가 1명이면 생략해도 백엔드가 알아서 고른다.
export const approvePassById = async (id, token, receiverMemberId) => {
  const query = receiverMemberId ? `?receiverMemberId=${encodeURIComponent(receiverMemberId)}` : '';
  return await mainCaller(`admin/api/v1/transfer/passes/${id}/approve${query}`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });
}

export const approveTicketById = async (id, token, receiverMemberId) => {
  const query = receiverMemberId ? `?receiverMemberId=${encodeURIComponent(receiverMemberId)}` : '';
  return await mainCaller(`admin/api/v1/transfer/tickets/${id}/approve${query}`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 승인 전 수신자 후보 조회 — 2명 이상이면 화면에서 고르게 한다.
export const getPassTransferReceivers = async (id, token) => {
  return await mainCaller(`admin/api/v1/transfer/passes/${id}/receivers`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export const getTicketTransferReceivers = async (id, token) => {
  return await mainCaller(`admin/api/v1/transfer/tickets/${id}/receivers`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 양도 롤백(취소) - 당일 한정. 원본 권 복원 + 양수자 권 만료 + 양수금 주문 취소를 백엔드가 일괄 처리.
export const cancelTicketTransfer = async (ticketTransferId, token) => {
  return await mainCaller(`admin/api/v1/transfer/tickets/${ticketTransferId}/cancel`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });
}

export const cancelPassTransfer = async (passTransferId, token) => {
  return await mainCaller(`admin/api/v1/transfer/passes/${passTransferId}/cancel`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 양도 탭: 회원이 보유한 양도 가능 수강권/이용권 목록
// 응답: [{ productType:'TICKET'|'PASS', productId, productName, paymentDate, startDate, expireDate, remainingCount, trainerName, status }]
export const getTransferableProducts = async (memberId, branchId, token) => {
  const query = QueryString.stringify({ branchId });
  return await mainCaller(`admin/api/v1/transfer/members/${memberId}/products?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 직접 양도(승인 단계 없음) - 수강권
export const directTransferTicket = async (memberCourseTicketId, body, token) => {
  return await mainCaller(`admin/api/v1/transfer/tickets/${memberCourseTicketId}/direct`, 'POST', body, {
    Authorization: `Bearer ${token}`,
  });
}

// 직접 양도(승인 단계 없음) - 이용권
export const directTransferPass = async (memberCoursePassId, body, token) => {
  return await mainCaller(`admin/api/v1/transfer/passes/${memberCoursePassId}/direct`, 'POST', body, {
    Authorization: `Bearer ${token}`,
  });
}

// 직접 양도(승인 단계 없음) - 기간 상품(운동복 등). 정회원(같은 지점 유효 수강권·이용권 보유)만 양수 가능
export const directTransferProduct = async (memberProductPassId, body, token) => {
  return await mainCaller(`admin/api/v1/transfer/products/${memberProductPassId}/direct`, 'POST', body, {
    Authorization: `Bearer ${token}`,
  });
}

export const getAllTransferProducts = async (query, token) => {
  return await mainCaller(`admin/api/v1/transfer/products?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 수강권·이용권·기간 상품·락커 양도기록 통합(최신순). 각 행 type=TICKET|PASS|PRODUCT|LOCKER, id=transferId
export const getAllTransfersMerged = async (query, token) => {
  return await mainCaller(`admin/api/v1/transfer/all?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 직접 양도 - 락커 패스 1개(#166). body.keepSpot=false 면 양수자 패스를 미배정으로 둔다(기본 같은 자리 유지)
export const directTransferLocker = async (memberLockerPassId, body, token) => {
  return await mainCaller(`admin/api/v1/transfer/lockers/${memberLockerPassId}/direct`, 'POST', body, {
    Authorization: `Bearer ${token}`,
  });
}

export const getAllTransferLockers = async (query, token) => {
  return await mainCaller(`admin/api/v1/transfer/lockers?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export const cancelLockerTransfer = async (lockerTransferId, token) => {
  return await mainCaller(`admin/api/v1/transfer/lockers/${lockerTransferId}/cancel`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });
}

export const cancelProductTransfer = async (productTransferId, token) => {
  return await mainCaller(`admin/api/v1/transfer/products/${productTransferId}/cancel`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });
}
